import { BadgeIndicator } from './BadgeIndicator';
import { Badge } from './Badge';

type BadgeListItemProps = {
  item: string;
  isActive: boolean;
};

export const BadgeListItem = ({ item, isActive }: BadgeListItemProps) => {
  return (
    <div className="relative" data-testid="badge-list-item">
      {isActive && <BadgeIndicator />}
      <Badge text={item} isActive={isActive} />
    </div>
  );
};
